import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { PromoReferenceService, PromoTypeService } from '../../../services/index';

@Component({
    selector: 'add-edit-promo-reference',
    templateUrl: './addEditPromoReference.component.html'
})
export class AddEditPromoReferenceComponent implements OnInit {

    @Output() promoReferenceLoadEvent = new EventEmitter();

    public title: string;
    public userType: string;
    public promoReferenceData: any = {};
    public isLoading: boolean = false;

    statusOptions = ['Active', 'Inactive'];
    promoTypeOptions: any[] = [];

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private promoReferenceService: PromoReferenceService,
        private promoTypeService: PromoTypeService
    ) { }

    ngOnInit(): void {
        if (this.promoReferenceData.mode === 'Add') {
            this.promoReferenceData.status = 'Active';
        }
        this.getActivePromoTypes();
    }

    onPromoTypeSelection(promoType: any): void {
        this.promoReferenceData.promo_type_id = promoType.promo_type_id;
        this.promoReferenceData.promo_type_display = promoType.promo_type;
    }

    getActivePromoTypes(): void {
        this.promoTypeService
            .getActivePromoTypes()
            .then((res: any) => {
                if (res && res.data) {
                    this.promoTypeOptions = res.data;
                    // For edit mode, set the display value
                    if (this.promoReferenceData.mode === 'Edit' && this.promoReferenceData.promo_type) {
                        this.promoReferenceData.promo_type_display = this.promoReferenceData.promo_type;
                    }
                }
            });
    }

    onSave(): void {
        this.isLoading = true;

        let params = {
            mode: this.promoReferenceData.mode,
            promo_type_id: this.promoReferenceData.promo_type_id,
            promo_reference: this.promoReferenceData.promo_reference,
            promo_reference_details: this.promoReferenceData.promo_reference_details || '',
            status: this.promoReferenceData.status
        };

        if (this.promoReferenceData.mode === 'Edit') {
            params['promo_reference_id'] = this.promoReferenceData.promo_reference_id;
        }

        this.promoReferenceService
            .addUpdatePromoReference(params)
            .then((res: any) => {
                this.isLoading = false;
                if (res && res.success) {
                    this.toasterService.pop({
                        type: 'success',
                        title: 'Success',
                        body: res.message
                    });
                    this.promoReferenceLoadEvent.emit();
                    this.bsModalRef.hide();
                } else {
                    this.toasterService.pop({
                        type: 'error',
                        title: 'Error',
                        body: res.message || 'Something went wrong'
                    });
                }
            })
            .catch(() => {
                this.isLoading = false;
                this.toasterService.pop({
                    type: 'error',
                    title: 'Error',
                    body: 'Something went wrong'
                });
            });
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/promoReference/addEditPromoReference.component.ts